import { MethodologyHero } from './methodology/MethodologyHero';
import { PipelineDiagram } from './methodology/PipelineDiagram';
import { TabsGuide } from './methodology/TabsGuide';
import { BadgesLegend } from './methodology/BadgesLegend';
import { AiDoesAndDoesnt } from './methodology/AiDoesAndDoesnt';
import { FaqWithExpand } from './methodology/FaqWithExpand';
import { DiagnosticsPanel } from './methodology/DiagnosticsPanel';
import { useLifecycleFeed } from '../hooks/useLifecycleFeed';

interface Props {
  onTabSwitch: (tab: 'today' | 'tracked' | 'analyses' | 'methodology') => void;
}

export function AboutMethodologyPage({ onTabSwitch }: Props) {
  const lifecycle = useLifecycleFeed(
    '/data/proposal-lifecycle.published.json',
    '/data/proposal-lifecycle.published.sample.json'
  );
  const diagnostics = lifecycle.status === 'ok' ? lifecycle.feed.diagnostics_only : [];
  const available = lifecycle.status === 'ok';

  return (
    <div className="methodology-page" data-testid="methodology-page">
      <MethodologyHero />
      <TabsGuide onTabSwitch={onTabSwitch} />
      <BadgesLegend />
      <PipelineDiagram />
      <AiDoesAndDoesnt />
      <FaqWithExpand />
      <DiagnosticsPanel items={diagnostics} available={available} />
    </div>
  );
}
